import { useTheme } from 'styled-components'
import { useMediaQuery } from '@material-ui/core'

/**
 * Custom hook to get viewport' info.
 */
const useViewport = () => {
  const theme = useTheme()
  const isDownToLarge = useMediaQuery(theme.breakpoints.down('lg'))
  const isDownToMedium = useMediaQuery(theme.breakpoints.down('md'))
  const isDownToSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const isDownToTiny = useMediaQuery(theme.breakpoints.down('xs'))
  const isLarge = useMediaQuery(theme.breakpoints.only('lg'))
  const isMedium = useMediaQuery(theme.breakpoints.only('md'))
  const isSmall = useMediaQuery(theme.breakpoints.only('sm'))
  const isTiny = useMediaQuery(theme.breakpoints.only('xs'))
  const isUpToLarge = useMediaQuery(theme.breakpoints.up('lg'))
  const isUpToMedium = useMediaQuery(theme.breakpoints.up('md'))
  const isUpToSmall = useMediaQuery(theme.breakpoints.up('sm'))
  const isUpToTiny = useMediaQuery(theme.breakpoints.up('xs'))

  return {
    size: {
      isDownToLarge,
      isDownToMedium,
      isDownToTiny,
      isDownToSmall,
      isLarge,
      isMedium,
      isSmall,
      isTiny,
      isUpToLarge,
      isUpToMedium,
      isUpToSmall,
      isUpToTiny,
      isDesktop: isUpToSmall,
      isMobile: isTiny
    }
  }
}

export default useViewport
